import { Operation } from '~/interfaces/device.interface';
import { LegrandGateway } from './LegrandGateway.model';
import operations from '~/helpers/device-operations';

export class BNHY extends LegrandGateway {

    MAX_TIME_BEFORE_UNKNOWN = 6 * 3600;

    get deviceOperations(): Operation[] {
        const deviceOperations = super.deviceOperations.concat([
            operations.triggerLogsDump({ callback: this.triggerLogsDump }),
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
        ]);
        if (this.homeId) {
            deviceOperations.push(operations.getLocalResources({ callback: this.getLocalResources }));
        }
        return deviceOperations;
    }
}
